import { createError, defineNuxtRouteMiddleware } from 'nuxt/app'

// 旧 URL 301 落地后的页面路径，继续展示现有 404 样式的 410 错误页。
const LEGACY_GONE_PATHS = ['/zh-cn/market/detail', '/zh-cn/liveroom', '/zh-cn/notice']

export default defineNuxtRouteMiddleware((to) => {
  const isGone = LEGACY_GONE_PATHS.some((path) => to.path === path || to.path.startsWith(`${path}/`))

  if (!isGone) return

  throw createError({
    statusCode: 410,
    statusMessage: 'Gone',
    fatal: true,
  })
})
